import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';

export default function RejectReasonDialog(props) {
  
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

 

  

  return (
    <React.Fragment>
      
      <Dialog
        fullScreen={fullScreen}
        fullWidth
        maxWidth="sm"
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Typography variant='h4'>Ops rejected reason</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
           {props.data?props.data.rejected_reason:null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={props.handleClose} autoFocus>
            close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
